import "$styles/index.scss"
import "./hearts"
import "./search"

import "bootstrap/dist/js/bootstrap.bundle"

window.jQuery = {}
import "theme/lumne-html/assets/js/plugins.min.js"
import "theme/lumne-html/assets/js/main.js"
